import script from "./Cover.vue?vue&type=script&setup=true&lang=js"
export * from "./Cover.vue?vue&type=script&setup=true&lang=js"

import "./Cover.vue?vue&type=style&index=0&id=0076fbf5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0076fbf5"]])

export default __exports__